const StaticImage = () => {
    return (
        <p>
            The{' '}
            <a href="http://features.pewforum.org/same-sex-marriage-attitudes/index.php">
                rise in support for same-sex marriage
            </a>
            over the past decade is among the largest changes in opinion on any
            policy issue over this time period. Fully 14% of all Americans – and
            28% of gay marriage supporters – say they{' '}
            <a href="https://www.people-press.org/2013/03/20/growing-support-for-gay-marriage-changed-minds-and-changing-demographics/">
                have changed their minds
            </a>{' '}
            on the issue in favor of gay marriage.
        </p>
    );
};

export default StaticImage;
